// extracted by mini-css-extract-plugin
export default {"container":"Project_container__7-BOB","header":"Project_header__jLMRM","image":"Project_image__a5PfU"};